<template>
  <div id="scheduled-order-notes-panel">
    <panel>
      <template #title>
        Order Notes
        <v-spacer></v-spacer>
        <v-icon
          @click="addNote"
        >
          mdi-plus
        </v-icon>
      </template>

      <template #content>
        <v-list
          v-if="comments.length > 0"
          dense
          two-line
          min-height="150"
          max-height="300"
        >
          <vue-scroll :ops="ops">
            <template v-for="(comment, i) in sort(comments)">
              <v-list-item :key="`comment-${i}`">
                <v-list-item-content>
                  <v-list-item-title style="white-space: normal;" v-text="comment.comment"></v-list-item-title>
                  <div class="caption">{{ comment.created_by }} - {{ comment.created_at }}</div>
                </v-list-item-content>
              </v-list-item>
              <v-divider class="p-0 m-0" :key="`comment-divider-${comment.id}`"></v-divider>
            </template>
          </vue-scroll>
        </v-list>
      </template>
    </panel>
<!--    <comment-modal :is-modal-active="dialogComment" :close-modal="toggleCommentModal" :add-comment="addNote" />-->
    <comment-modal ref="comment"></comment-modal>
  </div>
</template>

<script>
import vueScroll from 'vuescroll'

import { mapActions, mapState } from 'vuex'

export default {
  components: {
    Panel: () => import('@/components/Panel'),
    CommentModal: () => import('@/views/components/CommentModal'),
    vueScroll
  },
  data () {
    return {
      ops: {
        vuescroll: {
          sizeStrategy: 'number'
        },
        scrollPanel: {},
        rail: {},
        bar: {}
      }
    }
  },
  computed: {
    ...mapState('orderManagement', {
      order: state => state.scheduledOrder
    }),
    ...mapState('commentManagement', {
      comments: state => state.comments
    })
  },
  methods: {
    ...mapActions('commentManagement', {
      add: 'addComment',
      get: 'fetchComments',
      remove: 'removeComment'
    }),
    init () {
      this.loadComments()
    },
    loadComments () {
      this.get({model_id: this.$route.params.id, type: 'scheduled_order', internal: false})
        .then(() => {})
        .catch((error) => {
          this.$toast.error(error.data ? error.data.error : error)
        })
    },
    sort (notes) {
      return notes.slice().sort((a, b) => {
        return b.id - a.id
      })
    },
    addNote () {
      this.$refs.comment.open('Add Note')
        .then((note) => {
          const newNote = {
            model_type: 'scheduled_order',
            model_id: this.$route.params.id,
            reason_id: 5,
            comment: note
          }
          this.add(newNote)
            .then(() => {
              this.$toast.success('New comment added!')
            })
            .catch((error) => {
              this.$toast.error(error.data ? error.data.error : error)
            })
        })
        .catch(() => {})
    }
  },
  created () {
    this.init()
  }
}
</script>

<style scoped>

</style>
